import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#e7e6e3"
export default makeBasicTheme(mainColor)